export var PublisherCapacity;
(function (PublisherCapacity) {
    PublisherCapacity["AM"] = "AM";
    PublisherCapacity["OP"] = "OP";
    PublisherCapacity["SU"] = "SU";
})(PublisherCapacity || (PublisherCapacity = {}));
export var WriterCapacity;
(function (WriterCapacity) {
    WriterCapacity["C"] = "C";
    WriterCapacity["CA"] = "CA";
    WriterCapacity["ARR"] = "ARR";
})(WriterCapacity || (WriterCapacity = {}));
export var WorkingStatus;
(function (WorkingStatus) {
    WorkingStatus["Submitted"] = "Submitted";
    WorkingStatus["Received"] = "Received";
    WorkingStatus["InError"] = "In Error";
    WorkingStatus["Processed"] = "Processed";
})(WorkingStatus || (WorkingStatus = {}));
export class PublisherInfo {
    pubName = '';
    ipNumber = '';
    capacity = PublisherCapacity.OP;
    // adminName: string = '';
    controlled = false;
    affiliation = '';
}
export var WorkContentOptions;
(function (WorkContentOptions) {
    WorkContentOptions["MusicOnly"] = "Music";
    WorkContentOptions["Lyrics"] = "Music and Lyrics";
})(WorkContentOptions || (WorkContentOptions = {}));
export class WriterInfo {
    firstName = '';
    lastName = '';
    ipNumber = '';
    capacity = WriterCapacity.C;
    controlled = false;
    share = 0;
    affiliation = '';
    canSave() {
        if (this.ipNumber && !this.affiliation) {
            return false;
        }
        return true;
    }
}
class SongRegistration {
    songRegPk = '';
    songTitle = '';
    workContent = WorkContentOptions.Lyrics;
    songLanguage = 'en';
    ISWC = '';
    samples = false;
    altTitle = '';
    publisherInfo;
    writerInfo;
    workingStatus = WorkingStatus.Submitted;
    constructor(srOwner) {
        this.publisherInfo = new Array;
        this.writerInfo = new Array;
        this.songRegPk = srOwner;
    }
    getWorkCode() {
        return this.ISWC;
    }
    setWC(newWC) {
        this.ISWC = newWC;
    }
    setWorkCode(newWC) {
        if (this.isValidWorkCode(newWC)) {
            this.ISWC = WorkContentOptions[newWC];
        }
        else {
            throw new Error("the International Song Work Code, " + newWC + ", is not a member of WorkContentOptions.");
        }
    }
    isValidWorkCode(twc) {
        return Object.values(WorkContentOptions).includes(WorkContentOptions[twc]);
    }
    hasSamples(torf) {
        this.samples = torf;
    }
    getSamples() {
        return this.samples;
    }
}
export default SongRegistration;
